import {connect} from '@modifi/redux'
import {selectExtraLinks} from '../../../../../data/navigation'

import CountryAwareBrandLogo, {CountryAwareBrandLogoProps} from './CountryAwareBrandLogo'

const mapStateToProps = (
  state: Record<string, any>
): Pick<CountryAwareBrandLogoProps, 'homeUrl'> => ({
  homeUrl: selectExtraLinks(state)?.home,
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(CountryAwareBrandLogo)
